import React from 'react';
import HeadingSection from 'components/LandingPageHeadingSection/HeadingSection';
import Styles from './styles.js';
import Link from 'next/link';

const FeaturedLocations = ({
  title,

  card1hd,
  card1txt,
  card1btn,
  card2hd,
  card2txt,
  card2btn,

  card1Img,
  card2Img,

  
  href2,
  href3,
}) => {
  return (
    <>
      {title ? <HeadingSection title={title} bgcolor="white" /> : null}
      <div className="lg:container mx-auto   px-4 lg:px-6  ">
        <div className="grid md:grid-cols-2 grid-cols-1  gap-x-12  ">
          <div className=" min-h-full ">
            <div style={{minHeight:'inherit'}} className="flex flex-col justify-between  bg-transparent border-none">
              <div
                className="pt-8 mb-2  text-center flex justify-center items-center"
                style={{ minHeight: '70px' }}>
                <p className=" mb-2 text-2xl font-normal " style={{ fontFamily: 'Josefin Sans', color: '#1b1b1b' }}>
                  {card1hd}
                </p>
              </div>
              <img loading="lazy" src={card1Img} className=" w-full h-full rounded-0 pt-8 " alt="..." />
              <div className="flex flex-col text-center justify-center items-center pb-4 my-6">
                <div className="flex flex-col  justify-center items-center custom  mt-4 mb-4 pb-3 text-center" style={{ fontFamily: 'josefin Sans' }}>
                  <p className="text-xl min-height-exp  mt-2 mb-4 " style={{ fontFamily: 'Josefin Sans', color: '#5e5e5e' }}>
                    {card1txt}
                  </p>
                  <Link href={href2}>
                    <button type="button" className="btn rounded-0 mt-3 mt-md-0 mt-xl-3">
                      {card1btn}
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="min-h-full ">
            <div style={{minHeight:'inherit'}} className="flex flex-col text-center justify-between items-center bg-transparent border-none">
              <div
                className="card-title mb-2 pt-8 text-center flex flex-col text-center justify-center items-center"
                style={{ minHeight: '70px' }}>
                <h4 className="mb-2  text-2xl  font-normal  " style={{ fontFamily: 'Josefin Sans', color: '#1b1b1b' }}>
                  {card2hd}
                </h4>
              </div>
              <img loading="lazy" src={card2Img} className=" w-full h-full rounded-0 card-img-top pt-8" alt="..." />
              <div className="flex flex-col text-center justify-center items-center p-0 my-6 pb-4">
                <div className="flex flex-col text-center justify-center items-center custom  mt-4 mb-4 pb-3 text-center" style={{ fontFamily: 'josefin Sans' }}>
                  <p className="text-xl min-height-exp  mt-2 mb-4 " style={{ fontFamily: 'Josefin Sans', color: '#5e5e5e' }}>
                    {card2txt}
                  </p>
                  <Link href={href3}>
                    <button type="button" className="btn rounded-0 mt-3 mt-md-0 mt-xl-3">
                      {card2btn}
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Styles/>
    </>
  );
};

export default FeaturedLocations;
